import { useQuery } from '@tanstack/vue-query';
import apiInterceptor from '@/shared/apiInterceptor';
import { environment } from '@/shared/env';

export const livechatShortcutsQueryOptions = {
  queryKey: ['livechat-shortcuts'],
  queryFn: async () => {
    const r = await apiInterceptor.get(environment('VUE_APP_API_URL') + 'livechat/v1/settings/messages/shortcuts');
    return { ...r, shortcuts: [...(r.shortcuts ?? [])] };
  },
  staleTime: Infinity,
};

export function useLivechatShortcuts() {
  return useQuery(livechatShortcutsQueryOptions);
}
